import { Pill, type PillColor } from 'components/pill/Pill';
import { getKeyStatus, type ApiKeyStatusFields, type ApiKeyStatus } from '../utils/get-key-status';

const STATUS_COLORS: Record<ApiKeyStatus, PillColor> = {
  active: 'positive',
  revoked: 'negative',
  expired: 'neutral',
};

export interface ApiKeyStatusPillProps {
  apiKey: ApiKeyStatusFields;
  labels: Record<ApiKeyStatus, string>;
}

export const ApiKeyStatusPill: React.FC<ApiKeyStatusPillProps> = ({ apiKey, labels }) => {
  const status = getKeyStatus(apiKey);
  return <Pill color={STATUS_COLORS[status]}>{labels[status]}</Pill>;
};
